import { RESTproxy } from '../RESTproxy';

export class EconomyProxy extends RESTproxy {
    constructor() {
        super('report');
    }

    getEconomy() {
        return this.get('economy');
    }

    getWallets() {
        return this.get('economy/wallets');
    }
}
